// extracted by mini-css-extract-plugin
export default {"errorPage":"Error404_errorPage__QT2oH","container":"Error404_container__WLwTD","errorTitle":"Error404_errorTitle__8zFkA","errorDescription":"Error404_errorDescription__BW8FP"};